<template>
  <div id="app">
    <div v-for="(item, index) in tileSources" :key="`tileSource_${index}`" :style="`position:absolute!important; top: ${top}px; left:0px`">
    <div :id="`openseadragon-viewer_${index}`" :ref="`viewer_${index}`" :style="`width: 100vw; height: calc(100vh -  ${top}px);`" class="openseadragon-viewer" ></div>
    </div>
    <canvas ref="canvas" style="display: none;"></canvas>
  </div>
</template>

<script>
import OpenSeadragon from 'openseadragon';
import forge from 'node-forge'

export default {
  data() {
    return {
      viewers: [],
      top: 80
    };
  },
  props: {
    tileSources:{
      type: Array,
      required: true
    },
    colors:{
      type: Array,
      required: true
    },
    parameters: {
      type: [Object, null],
      required: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initOpenSeadragon();
      if(this.tileSources.length > 1){
        this.top = 80
      } else {
        this.top = 50
      }
    });
  },
  methods: {
    initOpenSeadragon() {
      //const viewerOptions = []
      for (let index = 0; index < this.tileSources.length; index++) {
        const element = this.tileSources[index];

        this.viewers[index] = OpenSeadragon({
          element: this.$refs['viewer_' + index][0],
          prefixUrl: 'openseadragon/images/',
          tileSources:[this.decryptText(element)],
          showNavigator: (index === this.tileSources.length - 1) ? true : false,
          showNavigationControl: false, //(index === this.tileSources.length - 1) ? true : false,
          showFullPageControl: false
        });

        if (this.colors.length > 0){
       this.viewers[index].addHandler('tile-loaded', (event) => {
      var canvas = document.createElement('canvas');
      canvas.width = event.data.width;
      canvas.height = event.data.height;
      var context = canvas.getContext('2d');

      context.drawImage(event.data, 0, 0);

      // Obtener los datos de la imagen
      var imageData = context.getImageData(0, 0, canvas.width, canvas.height);
      var data = imageData.data;

      var color = this.colors[index]
      for (var i = 0; i < data.length; i += 4) {
      if (data[i + 3] > 0) { // verifica si el canal alfa no es 0
        // Calcular la intensidad del blanco del píxel original
        var intensity = (data[i] + data[i + 1] + data[i + 2]) / 3 / 255;
        
        // Aplicar la intensidad al color deseado
        data[i] = color.R * intensity;    // R
        data[i + 1] = color.G * intensity; // G
        data[i + 2] = color.B * intensity; // B
        // El canal alfa se queda como está
    }
}
      
      context.putImageData(imageData, 0, 0);

      event.tile.context2D = context;


});
        }

        

      if (this.parameters !== null) {
          this.viewers[index].addHandler('open', () => {
          this.viewers[index].viewport.zoomTo(this.parameters.zoom);
          this.viewers[index].viewport.panTo(this.parameters.center);
        });
      }

      }
      if (this.tileSources.length > 1){
      this.viewers[this.tileSources.length -1].addHandler('zoom', this.viewerHandler);
      this.viewers[this.tileSources.length - 1].addHandler('pan', this.viewerHandler);
      }

      // Initialize Annotorious plugin
     /* const anno = window.OpenSeadragon.Annotorious(this.viewers[this.tileSources.length - 1]);

      // Load annotations in W3C WebAnnotation format
      anno.loadAnnotations('annotations.w3c.json'); // Ruta a tu archivo de anotaciones

      // Attach handlers to listen to events
      anno.on('createAnnotation', (a) => {
        // Manejar la creación de anotaciones
        console.log('Annotation created:', a);
      });
    */
    },
    viewerHandler() {
      const mainViewer =  this.viewers[this.tileSources.length - 1];
      const zoom = mainViewer.viewport.getZoom();
      const center = mainViewer.viewport.getCenter();

      this.$emit('params', { zoom, center });

       this.viewers.forEach((viewer, index) => {
        if (index !== this.tileSources.length - 1) {
          viewer.viewport.zoomTo(zoom);
          viewer.viewport.panTo(center);
        }
      });
    },
    zoomIn() {
      this.viewers[this.tileSources.length -1].viewport.zoomBy(2);
      this.viewers[this.tileSources.length -1].viewport.applyConstraints();
    },
    zoomOut() {
      this.viewers[this.tileSources.length -1].viewport.zoomBy(0.5);
      this.viewers[this.tileSources.length -1].viewport.applyConstraints();
    },
    goHome() {
      this.viewers[this.tileSources.length -1].viewport.goHome();
    },
    
    decryptText(encryptedText) {
      const privateKeyPem = `-----BEGIN PRIVATE KEY-----
MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQClPWxYuM0vbBQ0
SO4riSpyo+tL0pxIr9bFuFJQCZGyhLtOtu4yaZeB1iB9rT+URdEv6NxGGhmHmuWl
dLptRC4QL1S5K2cZ1fENMEb/6BUdmyPlullPyXO2+8rbDZoqFBLgfjNFR8tHqlWD
LGEhfCVeZWZvAkQEvsgDT3/f8dOwgeGDmQmpCSlW8rzYHfqfFYGoBSfBPLaLISYj
3h27+FLzJl5j0uPYPThceqY3xcmGfHWPmOBbXo8GNySEo3ValV1y7BjAlHuD8YKx
bWd9zV/HsXiiQlN2C6Nf4uU5QatTU7Em25nzqKKNVtt5DpfgmZCEldMT/Gkoer+s
2KVT8DODAgMBAAECggEAB5HPbwnvUbG1yzvRYqNmaKA/8kfs+OIf7CiaWShI13tj
V3g48hq1GvinTGGtmUaXuNt3xnHlamP+mSqp+k9vfMSKv0RfEaBcsTgyujkQ13SV
Ri27qMZCLzkTbsnxLK0voDEZl0irHtap2mZAR4KioAxmAOKDBPLaNB5l++kzNV+V
gBmkBaGVYsQSh6hSt4WJ5m54NkMQ7bz4I0wTzoghA2fFKCkwRsvuhCpcjvK6pd+V
vibagSp3YRaJWWXV4uQDpjjHI1m6qHH02yOPJl0U9Xtviw7fdLx6ZB8/S/FdBsro
zSp9etJqeKKrjMSBC4FKrA74S1KhUXmJnA2fRhzaoQKBgQDmD0xKRjxEuQI3HTra
xYEg1HhPNnkyxsLjydFsw4V6cSTgeNR8O5WRjYnrW/iF93BX0c8mhZSPkc3ujn0m
HNDskoy6+M2M/hItz9RKhpwCuUDoQT0+Y/+KuiviBD15aLtr1EQBuTXOqrdEAtvE
jlzaW4WiUKZscytxQkcSAWvMlwKBgQC33xfoVv2s8/6zCn6k7Cpoha0sugITyT8s
sHnp3C6rG6cYbvGO1mS5yXIz+251fqL7fDY1m5veGs8GI9kif28RX2hYih5+dowS
nkGQPQ6EcOcPFhRK183Kc2X/o1GTVqWlPFSrN4oP/xArnU31FmL+A2eD1EEWsn09
pLtIWFex9QKBgQDSK4GXjQh8A8QpU3Oz7qCjvFbYjrw0De53KKVAxnIHRJva0afU
gp6GJRatRA0LXdxs7ghfecMZUase118vVT3sEYmtOaSWvHkhDu8y0jxuJI1OYGMx
vyrxslhql1MNugcWYAlsxaWJUt4vrKjWrPPYq6mueh0/kAtM4a6JnXC8qwKBgHLC
C4LYIFV8p1+JUkeOml1H6TB8G2XL+eDjeAOMh5gFl0F5pMvYZV9LKjrlVyh/1CsP
eCn3J830f3c+knuke2alXFO+SI/3Xy8TlKn4YYIpkRxqVFnt3KPZaDSn8vb5YkMB
p3qBHGslbys5b3li8n/FEitGIyWOWvpJQRZDBOCtAoGADPL3ZGHKmSq0MgqxGvd9
qqDL6JefwnPsygU1MWnwKqdw9wtBjKcFOXB/OxH4PQ5UIMNbHzrF5mvw1G6MhOQw
iC6Sfrf+ukh2KWfZ+eykL0Ww+48MEiWuFZCZzbn483Vwyuy9XKxIJJ2LbNv4X4TH
qS+f1JrWLIC/YaWRu8xPx18=
-----END PRIVATE KEY-----`;

      try {
        const privateKey = forge.pki.privateKeyFromPem(privateKeyPem);
        const encryptedData = forge.util.decode64(encryptedText);
        const decrypted = privateKey.decrypt(encryptedData, 'RSA-OAEP', {
          md: forge.md.sha256.create()
        });
        return decrypted;
      } catch (error) {
        console.error('Error al descifrar el texto:', error);
        return [];
      }
    }
  },
};
</script>

<style scoped>
.openseadragon-viewer {
  width: 100%;
  height: 100%;
  position: absolute!important;
}
</style>
